import { Play, Pause, Music2 } from "lucide-react";
import { useAudio } from "@/context/AudioContext";
import { Reveal, LeafDivider } from "@/components/Reveal";

export const MusicSection = () => {
  const { playing, toggle, current, duration, seek } = useAudio();
  const pct = duration ? (current / duration) * 100 : 0;

  return (
    <section id="muziek" className="py-24 bg-brand-cream grain">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <LeafDivider label="Muziek" />
          <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mt-3">Luister naar ons lied</h2>
          <p className="font-body text-brand-inkSoft mt-4 text-lg leading-relaxed">
            Zachte klanken raken dieper dan woorden. Neem even de tijd, adem in, en laat dit lied je meenemen naar binnen.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="card-soft rounded-3xl p-8 mt-10 flex flex-col items-center" data-testid="music-player">
            <button
              data-testid="music-play-button"
              onClick={toggle}
              className="grid place-items-center w-20 h-20 rounded-full bg-brand-forest text-brand-cream transition-all hover:scale-105 shadow-lg"
              aria-label="Speel of pauzeer lied"
            >
              {playing ? <Pause size={30} /> : <Play size={30} className="ml-1" />}
            </button>
            <p className="font-display text-2xl text-brand-forest mt-5 flex items-center gap-2">
              <Music2 size={18} className="text-brand-gold" /> Ons lied
            </p>
            <div
              className="w-full max-w-md mt-5 h-1.5 rounded-full bg-brand-cream2 cursor-pointer overflow-hidden"
              onClick={(e) => {
                const r = e.currentTarget.getBoundingClientRect();
                seek(((e.clientX - r.left) / r.width) * duration);
              }}
            >
              <div className="h-full bg-brand-sage rounded-full" style={{ width: `${pct}%` }} />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
